import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type PriceState = {
  showPrice: boolean
}

const initialState: PriceState = {
  showPrice: false,
}

const priceSlice = createSlice({
  name: 'price',
  initialState,
  reducers: {
    setShowPrice: (state, action: PayloadAction<boolean>) => {
      state.showPrice = action.payload
    },
  },
})

export const { setShowPrice } = priceSlice.actions
export default priceSlice.reducer
